import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';

// 보안상 localStorage/sessionStorage 사용하지 않음
// Access Token은 메모리에만 저장, Refresh Token은 httpOnly 쿠키
export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // 직렬화 체크에서 제외할 액션들
        ignoredActions: [],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;